module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment05-2496d2f11fb78c764908ec3e6956a8f8.png";